import { v4 as uuidv4 } from 'uuid';
import { AddToCartButton } from '../../../../vtex-apps/add-to-cart-button/AddToCartButton/default';
import { ConditionLayoutProduct } from '../../../../vtex-apps/ConditionLayoutProduct/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { SellerAddToCart } from '../../../../vtex-apps/seller-selector/SellerAddToCart/default';
import { SellerBody } from '../../../../vtex-apps/seller-selector/SellerBody/default';
import { SellerHead } from '../../../../vtex-apps/seller-selector/SellerHead/default';
import { SellerHeadCell } from '../../../../vtex-apps/seller-selector/SellerHeadCell/default';
import { SellerName } from '../../../../vtex-apps/seller-selector/SellerName/default';
import { SellerPrice } from '../../../../vtex-apps/seller-selector/SellerPrice/default';
import { SellerPriceWithShipping } from '../../../../vtex-apps/seller-selector/SellerPriceWithShipping/default';
import { SellerRow } from '../../../../vtex-apps/seller-selector/SellerRow/default';
import { SellerShipping } from '../../../../vtex-apps/seller-selector/SellerShipping/default';
import { SellerSimulateShipping } from '../../../../vtex-apps/seller-selector/SellerSimulateShipping/default';
import { SellerTable } from '../../../../vtex-apps/seller-selector/SellerTable/default';

export default function SellerSelector() {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'SellerSelector',
		componentId: uuidv4(),
		props: FlexLayoutRow({
			blockClass: 'flex-row__seller-selector-1',
			mzTitle: 'MZ | SellerSelector',
		}).props,
		childrenComponents: [
			ConditionLayoutProduct({
				conditions: [
					{
						subject: 'hasMoreSellersThan',
						arguments: {
							value: 1,
						},
					},
					{
						subject: 'isProductAvailable',
					},
				],
				Then: SellerTable({}, [
					FlexLayoutRow(
						{
							blockClass: 'flex-row__seller-table-1',
							colGap: 3,
						},
						[
							FlexLayoutCol(
								{
									width: { desktop: '35%', tablet: '100%', phone: '100%' },
								},
								[SellerSimulateShipping()],
							),
							FlexLayoutCol(
								{
									width: { desktop: '100%', tablet: '100%', phone: '100%' },
									preventVerticalStretch: true,
								},
								[
									SellerHead({}, [
										SellerHeadCell({ title: 'Seller' }),
										SellerHeadCell({ title: 'Price' }),
										SellerHeadCell({ title: 'Shipping' }),
										SellerHeadCell({ title: 'Price With Shipping' }),
										SellerHeadCell({ title: 'Add To Cart' }),
									]),
									SellerBody({}, [
										SellerRow({}, [
											SellerName(),
											SellerPrice(),
											SellerShipping(),
											SellerPriceWithShipping(),
											SellerAddToCart(
												{},
												[],
												[
													AddToCartButton({
														blockClass: 'add-to-cart-button__pidg-2',
														text: 'Comprar',
													}),
												],
											),
										]),
									]),
								],
							),
						],
					),
				]),
				Else: null,
			}),
		],
	};
}
